export default {
    name: 'achievements-details',
    components: {},
    props: {
        questionnaire: Object,
        topics: Array
    },
    data() {
        return {
            items: {
                profile: false,
                assessment: false,
                recommendation: {
                    hasAny: false,
                    count: 0
                },
                goodTopicScore: false,
                excellentTopicScore: false,
                goodScore: false,
                excellentScore: false,
            }
        }
    },
    computed: {
        //hasProfileComplete() {
        //    return this.$achievements.hasProfileComplete();
        //},

        //hasAssessmentComplete() {
        //    return this.$achievements.hasAssessmentComplete();
        //},

        //hasRecommendationComplete() {
        //    return this.$achievements.hasRecommendationComplete();
        //},

        //hasGoodTopicScore() {
        //    return this.$achievements.hasGoodTopicScore();
        //},

        //hasExcellentTopicScore() {
        //    return this.$achievements.hasExcellentTopicScore();
        //},

        //hasGoodScore() {
        //    return this.$achievements.hasGoodScore();
        //},

        //hasExcellentScore() {
        //    return this.$achievements.hasExcellentScore();
        //},

        completeItemsCount() {
            return this.$achievements.getCompletedCount();
        },

        allAchievementsEarned() {
            let self = this;

            return Object.keys(self.items).every(function (key) {
                return self.items[key] === true;
            });
        }
    },
    mounted() {
        this.items = this.$achievements.getAchievements()
    },
    methods: {
    }
}
